<template>
  <div v-if="avvisi.length" class="mb-3">
    <div
      v-for="avviso in avvisi"
      :key="avviso.id"
      class="avviso-alert d-flex align-items-start"
    >
      <span class="fw-semibold fs-6">{{ avviso.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CartAvvisi",
  props: {
    avvisi: { type: Array, default: () => [] },
  },
};
</script>

<style scoped>
.avviso-alert {
  background: #fff8dd;
  color: #b78103;
  border: 1px solid #f6c000;
  border-radius: 8px;
  padding: 10px 14px;
  font-weight: 600;
  font-size: 0.9rem;
}

.avviso-alert + .avviso-alert {
  margin-top: 8px;
}
</style>
